import { createServiceRoleClient } from '@/lib/supabase/service'

export async function logAdminAction(input: {
  adminUserId: string
  action: string
  targetType: string
  targetId: string
  metadata?: Record<string, unknown>
}) {
  const supabase = createServiceRoleClient()

  const { error } = await supabase.from('admin_action_logs').insert({
    admin_user_id: input.adminUserId,
    action: input.action,
    target_type: input.targetType,
    target_id: input.targetId,
    metadata: input.metadata ?? {},
  })

  if (error) {
    console.error('Failed to write admin action log', error)
  }
}
